/**
 * Functions to determine Google Tag Manager settings
 * Contains defaults, which are overridden via environment variables.
 *
 * Functions are used instead of constants to allow potential for runtime changes.
 */

const isProduction = () => ['production'].includes(process.env.NEXT_PUBLIC_APP_ENV || '');

const gtmConfig = {
  googleTagManager: {
    id: () => process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID ?? 'GTM-PGK3FPN',
    auth: () => {
      if (process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_AUTH) {
        return process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_AUTH;
      }

      if (isProduction()) {
        return '';
      }

      return 'mwCHMkqBNSKtwzRHG310Lg';
    },
    env: () => {
      if (process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ENV) {
        return process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ENV;
      }

      if (isProduction()) {
        return '';
      }

      return 'env-26';
    },
  },
  googleAnalyticsId: () => {
    if (process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID) {
      return process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID;
    }

    if (isProduction()) {
      return 'UA-176718558-1';
    }

    return '';
  },
};

export default gtmConfig;
